<div class="card-container">
  <ng-content></ng-content>

  @if (!disabled) {
    <div
      [matMenuTriggerFor]="menu"
      class="menu-button"
      (click)="onParticipantClick($event)"
      [style.left.px]="menuX"
      [style.top.px]="menuY"
    ></div>
    <mat-menu #menu="matMenu" overlapTrigger="true">
      <div class="menu-title">
        {{ member.user.fullName }}
      </div>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="onSecureMessage()">Secure Message</button>
      <button mat-menu-item (click)="onViewProfileClick()">View Profile</button>
      @if (isCurrentUserAdmin) {
        <button
          mat-menu-item
          (click)="isAdmin ? onRemoveAdminClick() : onMakeAdminClick()"
        >
          {{ isAdmin ? "Remove as an Admin" : "Make Role Admin" }}
        </button>
      }
      @if (isCurrentUserAdmin) {
        <button mat-menu-item (click)="onRemovePartipantClick()">
          Remove from Role
        </button>
      }
    </mat-menu>
  }
</div>
